import { writable } from "svelte/store";

export const transactionStore = writable({
  percentageFee: 0,
  recepientAddress: '0x0000000000000000000000000000000000000000',
});
